<template>
  <RepartitionDoughnut
    ref="doughnut"
    v-bind="$attrs"
    :value="value"
    :data="data"
    orientation="vertical"
    :tooltips="false"
    :width="width"
    class="repartition-value-doughnut"
  >
    <template #default>
      <v-icon
        :disabled="valueDisabled"
        :size="iconSize"
        :style="[colorData.colorStyles]"
        :class="[colorData.colorClasses]"
      >
        {{ icon }}
      </v-icon>
    </template>

    <template #inset>
      <g
        :transform="valueMarkerTransform"
        :class="{ 'value-marker__disabled': valueDisabled }"
        class="value-marker"
      >
        <polygon
          :points="valueMarkerUnderlayPoints"
          :transform="valueMarkerUnderlayTransform"
          class="value-marker__underlay"
        />

        <polygon
          :points="valueMarkerOverlayPoints"
          :transform="valueMarkerOverlayTransform"
          :style="[colorData.colorStyles]"
          :class="[colorData.colorClasses]"
          class="value-marker__overlay"
        />
      </g>
    </template>
  </RepartitionDoughnut>
</template>

<script>
import { getTextColorData } from './colorUtils'
import RepartitionDoughnut from './repartition-doughnut.vue'

export default {
  name: 'RepartitionValueDoughnut',

  components: {
    RepartitionDoughnut
  },

  props: {
    value: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      default: 68
    },
    icon: {
      type: String,
      default: 'mdi-account'
    },
    iconSize: {
      type: Number,
      default: 32
    }
  },

  data () {
    return {
      doughnutComponent: null,

      markerOverlaySize: 12,
      markerOverlayOffset: 3,

      valueMarkerTransform: null,
      valueMarkerUnderlayPoints: null,
      valueMarkerUnderlayTransform: null,
      valueMarkerOverlayPoints: null,
      valueMarkerOverlayTransform: null
    }
  },

  computed: {
    colorData () {
      const valueItem = this.data.items.find(
        (item) => item.code === this.data.value
      )
      const valueColor = valueItem != null ? valueItem.color : 'secondary'

      return getTextColorData(valueColor)
    },

    valueItem () {
      return this.data.items.find((item) => item.code === this.data.value)
    },

    valueDisabled () {
      return this.value != null && this.value !== this.data.value && this.value !== 'TOUS'
    }
  },

  mounted () {
    this.doughnutComponent = this.$refs.doughnut

    const insetRadius = this.doughnutComponent.insetRadius

    const underlayHypothenuse = this.getHypothenuse(insetRadius)
    this.valueMarkerUnderlayPoints = this.getTrianglePoints(underlayHypothenuse)

    const underlayTranslation = insetRadius * Math.sin(Math.PI / 4)
    this.valueMarkerUnderlayTransform = `translate(0, ${-underlayTranslation})`

    const overlayHypothenuse = this.getHypothenuse(this.markerOverlaySize)
    this.valueMarkerOverlayPoints = this.getTrianglePoints(overlayHypothenuse)

    const overlaylayTranslation =
      insetRadius * Math.sin(Math.PI / 4) +
      underlayHypothenuse / 2 -
      overlayHypothenuse / 2 -
      this.markerOverlayOffset
    this.valueMarkerOverlayTransform = `translate(0, ${-overlaylayTranslation})`

    // La valeur de l'adherent n'est pas forcement representee dans la
    // repartition du groupe : valueItem vaut alors undefined et le calcul
    // plantait ici, empechant TOUT le graphique de s'afficher. Sans elle,
    // on laisse simplement le marqueur non positionne.
    if (this.valueItem != null) {
      this.valueMarkerTransform = `rotate(${(360 * (this.doughnutComponent.getItemStartValue(this.valueItem) + this.valueItem.percentage / 2)) / 100})`
    }
  },

  methods: {
    getHypothenuse (radius) {
      return Math.sqrt(2 * radius * radius)
    },

    getHeight (radius) {
      return radius / Math.sqrt(2)
    },

    getTrianglePoints (hypothenuse) {
      return `${-hypothenuse / 2} 0, 0 ${-hypothenuse / 2}, ${hypothenuse / 2} 0`
    }
  }
}
</script>

<style lang="scss" scoped>
.repartition-value-doughnut {
  .value-marker {
    &.value-marker__disabled {
      .value-marker__overlay {
        opacity: 0.25;
      }
    }

    .value-marker__underlay {
      fill: #ffffff;
      stroke: none;
    }

    .value-marker__overlay {
      fill: currentColor;
      stroke: none;
    }
  }
}
</style>
